<template>
  <v-card>
    <v-card-title class="text-center pb-0 pl-6">
      <h3>Edit Time Windows</h3>
      <v-spacer></v-spacer>
      <v-btn text color="blue darken-1" @click="createTimeWindow">Create a new time window</v-btn>
    </v-card-title>

    <v-container grid-list-xs pt-0 pb-2 style="height: 80%">
      <v-row>
        <v-col md="4" cols="12">
          <v-text-field v-model="search" label="Search..." prepend-inner-icon="search"></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-divider color="#42a5f5"></v-divider>
    <v-card-text>
      <v-row justify="center">
        <v-col cols="12">
          <v-data-table
            v-if="timeWindows"
            :items="timeWindows"
            :headers="headers"
            :search="search"
          >
            <template v-slot:item="props">
              <tr v-if="editedIndex !== timeWindows.indexOf(props.item)">
                <td
                  style="text-align: center"
                  v-for="(header, index) in headers"
                  :key="index"
                  v-if="header.text !== 'Actions'"
                >{{props.item[header.value]}}
                </td>
                <td style="text-align: center">
                  <v-icon small @click="editClick(props.item)" class="pr-1">fas fa-edit</v-icon>
                  <v-icon small @click="deleteClick(props.item)" color="red">fas fa-trash</v-icon>
                </td>
              </tr>
              <tr v-else>
                <td style="text-align: center">{{props.item.id}}</td>
                <td style="text-align: center"
                    v-for="(header, index) in headers"
                    :key="index"
                    v-if="header.editable">
                  <v-select
                    v-model="editedRow[header.value]"
                    :items="header.select"
                    v-if="header.editField === 'select'"
                  ></v-select>
                </td>

                <td style="text-align: center" v-if="props.item.id===0">
                  <v-menu
                    v-model="startMenu"
                    ref="menuStart"
                    offset-y
                    :close-on-content-click="false"
                    :return-value.sync="editedRow.time_start"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="editedRow.time_start"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="startMenu"
                      format="24hr"
                      @click:minute="$refs.menuStart.save(editedRow.time_start)"
                      :allowed-minutes="allowedMinutes"
                      v-model="editedRow.time_start"
                    ></v-time-picker>
                  </v-menu>
                </td>
                <td style="text-align: center" v-else>{{props.item.time_start}}</td>
                <td style="text-align: center" v-if="props.item.id===0">
                  <v-menu
                    v-model="endMenu"
                    ref="menuEnd"
                    offset-y
                    :close-on-content-click="false"
                    :return-value.sync="editedRow.time_end"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="editedRow.time_end"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="endMenu"
                      format="24hr"
                      :min="editedRow.time_start"
                      @click:minute="$refs.menuEnd.save(editedRow.time_end)"
                      :allowed-minutes="allowedMinutes"
                      v-model="editedRow.time_end"
                    ></v-time-picker>
                  </v-menu>
                </td>
                <td style="text-align: center" v-else>{{props.item.time_end}}</td>
                <td style="text-align: center" v-if="props.item.id===0">
                  <v-text-field
                    v-model="editedRow.sort_code_suffix"
                    :rules="requiredRule"
                  ></v-text-field>
                </td>
                <td style="text-align: center" v-else>{{props.item.sort_code_suffix}}</td>
                <td>
                  <v-icon small @click="closeEdit" class="pr-1 ml-1">fas fa-times</v-icon>
                  <v-icon small @click="saveEdit" color="green">fas fa-check</v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card-text>


    <v-dialog
      v-model="confirmDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          ATTENTION
        </v-card-title>
        <v-card-text>
          Are you sure you want to delete this time window ? <br>
          This action cannot be undone.
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text color="blue-grey lighten-2" @click="toBeDeleted=null;confirmDialog=false">No</v-btn>
          <v-btn text color="blue darken-1" @click="deleteRow()">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import axios from 'axios'

export default {
  name: "ManageTimeWindows",
  props: {
    region: Object,
    toggleEditDialog: Function,
    zoneViewPermission: Boolean,
  },
  data() {
    return {
      search: null,
      startMenu: false,
      endMenu: false,
      confirmDialog: false,
      toBeDeleted: null,
      timeWindows: null,
      editedIndex: -1,
      editedRow: {
        id: 0,
        routing_rule: null,
        restricted: null,
        priority: null,
        day: null,
        time_start: null,
        time_end: null,
        sort_code_suffix:null
      },
      defaultRow: {
        id: 0,
        day: null,
        time_start: null,
        time_end: null,
        routing_rule: null,
        restricted: null,
        priority: null,
        sort_code_suffix:null
      },
      headers: [
        {text: 'ID', value: 'id', align: 'center', sortable: true, editable: false},
        {
          text: 'Routing Rule',
          value: 'routing_rule',
          align: 'center',
          sortable: false,
          editable: true,
          editField: 'select',
          select: ['Afternoon', 'Day', 'Evening', 'Late Evening', 'Morning', 'Overnight']
        },
        {
          text: 'Restricted',
          value: 'restricted',
          align: 'center',
          sortable: false,
          editable: true,
          editField: 'select',
          select: [true, false]
        },
        {
          text: 'Priority',
          value: 'priority',
          align: 'center',
          sortable: false,
          editable: true,
          editField: 'select',
          select: ['Low', 'Normal', 'High']
        },
        {
          text: 'Day',
          value: 'day',
          align: 'center',
          sortable: true,
          editable: true,
          editField: 'select',
          select: [
            'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
          ]
        },
        {text: 'Start', value: 'time_start', align: 'center', sortable: true, editable: false},
        {text: 'End', value: 'time_end', align: 'center', sortable: true, editable: false},
        {text: 'Sort Code Suffix', value: 'sort_code_suffix', align: 'center', sortable: true, editable: false, editField:'text',width:'10%'},
        {text: 'Actions', value: 'actions', align: 'center', sortable: false, editable: false},
      ],
      requiredRule: [
        v => !!v || 'This sort code suffix is required, from A to Z.'
      ],
    }
  },
  methods: {
    allowedMinutes: v => !(v % 30),
    deleteClick(item) {
      this.confirmDialog = true;
      this.toBeDeleted = item;
    },
    deleteRow() {
      this.confirmDialog = false;
      const index = this.timeWindows.indexOf(this.toBeDeleted);
      axios.delete(process.env.API_URL + '/timewindows/' + this.toBeDeleted.id)
        .then((response) => {
          this.timeWindows.splice(index, 1);
          this.toBeDeleted = null;
        })
        .catch((response) => {
          this.$emit('alert', response.response.data.error);
        })
    },
    getTimeWindows() {
      let suffix = '';
      if (this.zoneViewPermission) {
        suffix = suffix + '?show_all=true';
      }
      axios.get(process.env.API_URL + '/regions/' + this.region.id + '/timewindows' + suffix)
        .then((response) => {
          this.timeWindows = response.data;
        })
        .catch((response) => {
          this.$emit('alert', response.response.data.error);
        })
    },
    editClick(item) {
      this.editedRow = Object.assign({}, item);
      this.editedIndex = this.timeWindows.indexOf(item);
    },
    closeEdit() {
      if (this.editedRow.id === 0) {
        // Empty line created but user wants to cancel this creation
        // const index = this.timeWindows.indexOf(this.editedRow);
        this.timeWindows.splice(0, 1);
      }
      this.editedIndex = -1;
      this.editedRow = Object.assign({}, this.defaultRow);
    },
    createTimeWindow() {
      this.editedRow = Object.assign({}, this.defaultRow);
      this.timeWindows.unshift(this.editedRow);
      this.editedIndex = 0;
    },
    validationInput(body){
      if(body.sort_code_suffix === undefined || body.sort_code_suffix === null){
        this.$store.commit('displaySnackbar', 'sort code suffix not exist');
        return false;
      }
      if(!body.sort_code_suffix.match(/^[a-zA-Z]$/)){
        this.$store.commit('displaySnackbar', 'Invalid sort code suffix,it is from A to Z');
        return false;
      }
      return true;
    },
    saveEdit() {

      if(!this.validationInput(this.editedRow)) return;
      this.editedRow.sort_code_suffix = this.editedRow.sort_code_suffix.toUpperCase();

      if (this.editedRow.id > 0) {
        axios.put(process.env.API_URL + '/timewindows/' + this.editedRow.id, this.editedRow)
          .then((response) => {
            Object.assign(this.timeWindows[this.editedIndex], response.data);
            this.$store.commit('displaySnackbar', 'Time window modified');
            this.closeEdit();
          })
          .catch((response) => {
            this.$emit('alert', 'ERROR ' + response.error);
            this.closeEdit();
          });
        // Object.assign(this.timeWindows[this.editedIndex], this.editedRow);
      } else {
        this.editedRow.region = this.region.id;
        axios({
          method: 'post',
          url: process.env.API_URL + '/timewindows',
          data: this.editedRow
        })
          .then((response) => {
            // this.timeWindows.unshift(response.data);
            Object.assign(this.timeWindows[0], response.data);
            this.$store.commit('displaySnackbar', 'Time window created');
            this.editedIndex = -1;
            this.editedRow = Object.assign({}, this.defaultRow);
            // this.closeEdit();
          })
          .catch((response) => {
            this.closeEdit();
          });
      }

    }

  },
  mounted() {
    this.getTimeWindows();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/Zones/ManageTimeWindows.vue